import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { RootState } from 'af-reducers';

import type { UserTypeFilterOption } from 'ab-enums/userTypeFilter.enum';
import { getUserTypeFilterOptions } from 'ab-enums/userTypeFilter.enum';

import AdditionalFilter from 'af-components/Table/Filters/AdditionalFilter/Singleselect';

interface OwnProps {
	onChange: (id: UserTypeFilterOption) => void;
	forBulkModal?: boolean;
	onClear?: () => void;
	autoOpen?: boolean;
	selected: Nullable<UserTypeFilterOption>;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const AssignmentFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		companyData,
		userData,
		forBulkModal,
		onClear,
		autoOpen,
		selected: defaultSelected,
	} = props;

	const options = React.useMemo(() => getUserTypeFilterOptions(companyData, userData), [companyData, userData]);

	const onValueChange = React.useCallback((option: UserTypeFilterOption) => {
		onChange(option);
	}, [onChange]);

	const selected = React.useMemo(() => {
		return options.find((option) => option.id === defaultSelected?.id) ?? null;
	}, [defaultSelected?.id, options]);

	return (
		<AdditionalFilter
			autoOpen={!!autoOpen}
			filterName="Assignment"
			forBulkModal={!!forBulkModal}
			onChange={onValueChange}
			onRemoveFilter={onClear}
			options={options}
			selected={selected}
		/>
	);
};

function mapStateToProps(state: RootState) {
	const { companyData, userData } = state.user;

	if (!companyData || !userData) {
		throw new Error('User not logged in');
	}

	return {
		userData: userData,
		companyData: companyData,
	};
}

const connector = connect(mapStateToProps, null);

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(AssignmentFilter);
